// extracted by mini-css-extract-plugin
export default {"container":"ContractorsResult_container__PA+BL","row":"ContractorsResult_row__SaCM2","count":"ContractorsResult_count__Pv-Rj","total":"ContractorsResult_total__vaPHE"};